import { CreateAttachmentsFunc } from '../types/CreateAttachmentsFunc';
import { CreateAttachmentHandler } from 'owa-attachment-filepicker';
import { AttachmentWellViewState, CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { lazyGetGroupDisplayName } from 'owa-group-utils';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import {
    lazyShowAttachmentFolderPicker,
    AttachmentFolderPickerClientProviderType,
    AttachmentFolderPickerProperties,
} from 'owa-attachment-folder-picker';

export function getCreateAttachmentHandlerForUpsell(
    viewState: AttachmentWellViewState,
    createAttachment: CreateAttachmentsFunc
): CreateAttachmentHandler {
    const handler: CreateAttachmentHandler = async createAttachmentHandlerParams => {
        const showAttachmentFolderPicker = await lazyShowAttachmentFolderPicker.import();

        if (isConsumer()) {
            // In case it is a consumer user we directly create an attachment from the
            // selected file
            const properties: CreateAttachmentsProperties = {
                isInline: createAttachmentHandlerParams.isInline,
                isHiddenInline: false,
                shouldShare: true,
            };

            createAttachment(
                createAttachmentHandlerParams.files,
                properties,
                createAttachmentHandlerParams.dataProviderType
            );
        } else {
            // If it is not a consumer user then we give them option to choose the folder where to
            // upload the file and then create attachment from the selected file
            let properties: AttachmentFolderPickerProperties = {
                providerInfo: { type: AttachmentDataProviderType.OneDrivePro },
            };

            if (viewState.groupId) {
                const getGroupDisplayName = await lazyGetGroupDisplayName.import();
                const groupDisplayName = getGroupDisplayName(viewState.groupId);

                properties = {
                    providerInfo: {
                        type: AttachmentFolderPickerClientProviderType.Group,
                        groupMailboxId: viewState.groupId,
                        groupDisplayName: groupDisplayName,
                    },
                };
            }

            const result = await showAttachmentFolderPicker(properties);

            if (result.isFolderSelected) {
                // If a folder was selected only then create attachment
                const { folderInfo } = result;

                const properties: CreateAttachmentsProperties = {
                    isInline: createAttachmentHandlerParams.isInline,
                    isHiddenInline: false,
                    shouldShare: true,
                    shareProperties: {
                        folderInfo,
                        groupMailboxId:
                            result.providerType === AttachmentFolderPickerClientProviderType.Group
                                ? result.groupMailboxId
                                : null,
                    },
                };

                createAttachment(
                    createAttachmentHandlerParams.files,
                    properties,
                    createAttachmentHandlerParams.dataProviderType
                );
            }
        }
    };
    return handler;
}
